<style scoped>
    .min-page-height {
        min-height: 300px;;
    }
    .h-height {
        height: 40px;
    }
    .h-size {
        font-size: 1rem;
    }
    .c-lpad-50 {
        padding-left: 50px;
    }
</style>
<template>
    <div>
        <v-card>
            <v-card-title>
                Integration Errors
            </v-card-title>
            <v-card-text class="p-0">
                <div v-if="integrationId" class="mx-5">
                    <v-progress-linear
                        v-if="isLoading"
                        indeterminate
                        color="primary"
                        class="mb-5">
                    </v-progress-linear>
                    <v-form
                        ref="form"
                        @submit="onSubmit">

                        <div>
                            <v-row>
                                <v-col cols=12 class="h-height">
                                    <v-btn
                                        class=""
                                        icon
                                        color="secondary">
                                        <v-icon dark>
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                    <span class="h-size">Schedule the date to suppress the error from receiving.</span>
                                </v-col>
                                <v-col cols="6" md="3" lg="3" class="d-flex">
                                    <v-icon class="mr-3">mdi-calendar</v-icon>
                                    <v-datetime-picker
                                        v-model="errorData.date"
                                        label="Date">
                                    </v-datetime-picker>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols=12 class="h-height">
                                    <v-btn
                                        class=""
                                        icon
                                        color="secondary">
                                        <v-icon dark>
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                    <span class="h-size">List down all errors (status code or text) to exclude in receiving email error.</span>
                                </v-col>
                                <v-col cols="6" md="6" lg="6" class="c-lpad-50">
                                    <v-textarea
                                        v-model="errorData.text_list"
                                        counter
                                        auto-grow
                                        label="Errors list"
                                        rows="3"
                                        row-height="55"
                                        color="orange orange-darken-4">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                        </div>


                        <div class="d-flex p-3">
                            <v-spacer></v-spacer>
                            <v-btn small type="submit" color="primary">Save</v-btn>
                        </div>
                    </v-form>

                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import moment from 'moment'

export default {
    props: {
        id: { type: Number, default: null },
        metas: { type: Array, default: [] }
    },

    data() {
        return {
            isLoading: false,
            item: this.metas,
            startShowDate: false,
            endShowDate: false
        }
    },

    computed: {
        integrationId() {
            return this.id
        },

        errorData() {
            let errorData = this.item.map(key => {
                if (key.meta_key === "INTEGRATION_ERRORS") {
                    let error = JSON.parse(key.meta_value)
                    if (error.date != null && error.date != '') {
                        error.date = moment(error.date).format('YYYY-MM-DD hh:mm')
                    }
                    return error
                }
            })
            errorData = errorData.filter(val=>val)
            if (!errorData.length) {
                errorData.push({date:"",text_list:""});
            }

            return errorData[0]
        }
    },

    methods: {


        async onSubmit(e) {
            e.preventDefault();

            // stops spam
            if (this.isLoading) {
                return;
            }

            try {

                this.isLoading = true

                this.$http
                    .post('/api/integrations/errors', {
                        integration_id: this.id,
                        data: this.errorData
                    })
                    .then((data) => {
                        if (data.data.status != 'fail') {
                            EventBus.$emit('show-success', 'Successfully saved integration errors.');
                        }
                        else {
                            EventBus.$emit('show-error', data.data.message);
                        }
                    })



                this.isLoading = false
            } catch (err) {
                EventBus.$emit('show-err', err);

                this.isLoading = false
            }
        }
    }
}
</script>